module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-293.7e26e4a.woff2";